import * as React from 'react';
import { Wrapper, Patner, Link } from './styled';
import * as LogoVisa from '@app/src/assets/img/logo-visa.svg';
import * as LogoMasterCard from '@app/src/assets/img/logo-mastercard.svg';
import * as LogoPagoEfectivo from '@app/src/assets/img/logo-pagoefectivo.svg';

interface Props {
  className?: string;
}

export const Security: React.FC<Props> = ({className}) =>
  <Wrapper className={className}>
    <span>Tu Compra es 100% segura:</span>
    <Link href="https://www.visanet.com.pe/" target="_blank">
      <Patner src={LogoVisa} alt="visa"/>
    </Link>
    <Link href="https://www.mastercard.com.pe/es-pe/consumidores.html" target="_blank">
      <Patner src={LogoMasterCard} alt="mastercard"/>
    </Link>
    <Link href="https://pagoefectivo.pe/pe" target="_blank">
      <Patner src={LogoPagoEfectivo} alt="pago efectivo"/>
    </Link>
  </Wrapper>
